import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getPostHome, getCampaingActive } from "../../actions/homeActions";

import inMemoryJWT from '../../auth/inMemoryJwt';
import { viewStoriesHome, seeStoriesHome } from '../../actions/userActions'
import MasoryPostLayout from '../../containers/Post/MasoryPost/MasoryPost'
import WhitOutPost from '../../containers/Post/WhitOutPost/WhitOutPost';

const HomePost = ({ history, getPostHome, getCampaingActive, isLoading, postHome, postHomeCampaign, hasMore, page }) => {

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            // if (!postHome.length) {
            getCampaingActive()
            getPostHome(page, () => { })

            //}
        })

    }, [])

    const scrollHandler = (e) => {
        console.log();
        if (e.target.scrollTop + 1 >= e.target.scrollHeight - e.target.clientHeight) {
            // alert("ss")
            console.log();
            if (hasMore) {
                getPostHome(page + 1)
            }
        }
    }



    if (postHome.length > 0) {
        return <MasoryPostLayout scrollHandler={scrollHandler} isLoading={isLoading}
            postHomeCampaign={postHomeCampaign}
            masoryPost={postHome} linkPath={"/Post/"} />
    } else {
        return <WhitOutPost />
    }




}

const mapStateToProps = (state) => {
    return {
        isLoading: state.home.isLoadingPostHome,
        postHome: state.home.postHome,
        page: state.home.page,
        hasMore: state.home.hasMore,
        postHomeCampaign: state.home.postHomeCampaign
    }
}

const compareProsp = (prevMovie, nextMovie) => {
    return prevMovie.postHome === nextMovie.postHome;
}

/* export default connect(mapStateToProps, { getPostHome, viewStoriesHome, seeStoriesHome })(HomePost) */
export default connect(mapStateToProps, { getPostHome, viewStoriesHome, seeStoriesHome, getCampaingActive })(React.memo(HomePost, compareProsp))



